var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('our-heading',{attrs:{"title":"My profile"}}),_c('mfa-profile-panel')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }